export var getWidgetsNames = function getWidgetsNames(sections) {
  var widgetsName = '';
  if (!sections || sections.length == 0) {
    return widgetsName;
  }
  widgetsName = sections.reduce(function (names, section) {
    var _section$widgets = section.widgets,
      widgets = _section$widgets === void 0 ? [] : _section$widgets;
    names = widgets.reduce(function (_names, widget) {
      _names += "".concat(_names ? ', ' : '').concat(widget.name);
      return _names;
    }, names);
    return names;
  }, widgetsName);
  return widgetsName;
};